import { SCENE_DIR_MNG } from '@/api/apiModules'
import lang from '@/lang'
export default {
  viewType: 'form',
  module: SCENE_DIR_MNG,
  callBackAction: '',
  params: null,
  extraParams: null,
  formatData(data) {
    data.industryId = this.extraParams?.industryId
    return data
  },
  view: {
    labelWidth: '180px',
    width: '650px',
    title: '创建场景目录',
    labelPosition: 'right',
    content: [
      {
        $id: 'sceneDirName',
        $type: 'input',
        label: '场景目录',

        rules: [
          {
            notEmpty: '场景目录'
          },
          [
            {
              max: 16,
              message: lang.t('sk.form.common_term_maxlength_valid', {
                max: 16
              })
            }
          ]
        ]
      },
      {
        $id: 'sceneDirDesc',
        $type: 'input',
        $el: {
          type: 'textarea',
          rows: 5
        },
        label: '场景目录描述'
      }
    ]
  }
}
